import React, { useEffect } from 'react'
import Confetti from 'react-confetti'
import { makeStyles } from '@material-ui/core'
import { Fade, Modal } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { COLORS } from 'src/utils/Themes/colors'

const CongratulationsConfettiModal = ({
  openConfettiModal,
  message,
  handleClose,
}) => {
  const classes = useStyles()

  useEffect(() => {
    if (openConfettiModal) {
      const timer = setTimeout(() => {
        handleClose()
      }, 4000)

      return () => clearTimeout(timer)
    }
  }, [openConfettiModal, handleClose])

  return (
    <Modal
      open={openConfettiModal}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openConfettiModal}>
        <div className={classes.outerDiv}>
          {openConfettiModal && <Confetti recycle={false} />}
          <div className={classes.modalStyle}>
            <div>
              <h1 className={classes.heading}>Congratulations!!</h1>
              <p>{message ? message : null}</p>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

export default CongratulationsConfettiModal

const useStyles = makeStyles({
  modalStyle: {
    position: 'absolute',
    // marginTop: '50%',
    // left: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    padding: 50,
  },
  clickHereText: {
    cursor: 'pointer',
    color: COLORS.DARK_PINK,
  },
  clsBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  outerDiv: {
    paddingTop: '25%',
    paddingLeft: '50%',
  },
  heading: {
    color: COLORS.DARK_PINK,
  },
})
